// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lang[data-v-478764a7]{width:100%}.lang[data-v-478764a7] .el-form-item__content{width:79%}", ""]);
// Exports
module.exports = exports;
